import { render } from "./ExamEventRegistrations.vue?vue&type=template&id=639bfe51&scoped=true"
import script from "./ExamEventRegistrations.vue?vue&type=script&lang=js"
export * from "./ExamEventRegistrations.vue?vue&type=script&lang=js"

import "./ExamEventRegistrations.vue?vue&type=style&index=0&id=639bfe51&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639bfe51"]])

export default __exports__